import Tabs from './tabs';
import TabPane from './tab-pane';

/* istanbul ignore next */
Tabs.install = function(Vue) {
  Vue.component(Tabs.name, Tabs);
  Vue.component(TabPane.name, TabPane);
};

export default Tabs;
